module.exports = "/packs/step4_sp-0c7dd6eeda57820bf606e6f090b1959c.png";